import { type ElementBase } from '../elements/element-base';

import { type QuestionBase } from './question-base';
import { type QuestionContainer } from './question-container';
import { type QuestionGroup } from './question-group';
import { type QuestionPercentage } from './question-percentage';

export function isQuestionContainer(
  element: ElementBase,
): element is QuestionContainer {
  return element.elementType === 'container';
}

export function isQuestionPercentage(
  element: QuestionBase<any>,
): element is QuestionPercentage {
  /**
   * A questionPercentage have an elementType 'textbox' like other questions, so we need to check the type.
   */
  return element.type === 'percent';
}

export function isQuestionGroup(
  element: ElementBase,
): element is QuestionGroup<any> {
  return element.elementType === 'group';
}
